import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Player } from '@lottiefiles/react-lottie-player';

export const LottiePlayer = styled(Player)`
  position: absolute;
  width: 40px;
  height: 40px;
`;

export const Container = styled(Box)`
  padding-bottom: 160px;
`;

export const Heading = styled(Typography)`
  color: #6c7589;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 40px;
`;

export const ProgressBar = styled(Box)`
  height: 36px;
  border-radius: 12px;
  box-shadow: 1px 2px 2px 0px rgba(0, 0, 0, 0.25);
  animation-fill-mode: both;
  animation-duration: 5s;
  animation-timing-function: cubic-bezier(0.33, 1, 0.68, 1);
  margin-bottom: 12px;
`;
